export enum BKK {
  'กรุงเทพมหานคร',
  'กรุงเทพฯ',
  'กรุงเทพ',
  'กทม',
  'กทม.',
  'BKK',
  'BKK.',
  'Bangkok',
}

export const PROVINCE_PREFIX = {
  EN: 'Province',
  TH: {
    CMM: 'จังหวัด',
    SHORT: 'จ.',
  },
}

export const DISTRICT_PREFIX = {
  EN: 'District',
  TH: {
    BKK: 'เขต',
    CMM: 'อำเภอ',
    SHORT: 'อ.',
  },
}

export const SUBDISTRICT_PREFIX = {
  EN: 'Subdistrict',
  TH: {
    BKK: 'แขวง',
    CMM: 'ตำบล',
    SHORT: 'ต.',
  },
}
